// Composants partagés du design Fit by Daya (accueil + pages d'achat)
import Link from "next/link"
import Image from "next/image"
import MobileMenu from "./MobileMenu"
import "./fbd.css"

export const SOCIALS = [
  ["https://instagram.com/fit_by_daya", "Instagram"],
  ["https://tiktok.com/@fit_by_daya", "TikTok"],
]

// Liens de navigation pour les pages autres que l’accueil
export const SITE_NAV = [["/#parcours", "Mon parcours"], ["/#programme", "Le programme"], ["/#methode", "La méthode"], ["/#faq", "FAQ"]]

// Coquille commune des pages secondaires : en-tête, contenu, pied de page
export function PageShell({ children, bg = "#FBF7F4" }) {
  return (
    <div className="fbd" style={{ minHeight: "100vh", display: "flex", flexDirection: "column", backgroundColor: bg }}>
      <SiteHeader links={SITE_NAV} cta={<Link className="btn btn-primary hdr-cta" href="/coaching-pdf" style={{ minHeight: 44, padding: "0 22px", fontSize: 14 }}>Le programme</Link>} />
      <main style={{ flex: 1 }}>{children}</main>
      <SiteFooter />
    </div>
  )
}

// Affiché à la place des pages compte tant que Supabase est désactivé
export function MembersClosed() {
  return (
    <PageShell bg="#FBE9EE">
      <div className="wrap" style={{ display: "flex", justifyContent: "center", padding: "clamp(56px, 8vw, 112px) var(--fbd-gutter)" }}>
        <div className="shop-card" style={{ maxWidth: 520, width: "100%", textAlign: "center" }}>
          <div className="kicker">ESPACE MEMBRE</div>
          <h1 className="t-h2" style={{ marginTop: 16 }}>Bientôt <em className="em">disponible</em></h1>
          <p className="t-body" style={{ marginTop: 16, fontSize: 15 }}>
            Les comptes et le suivi en ligne arrivent bientôt. En attendant, le programme 60 jours est disponible en PDF.
          </p>
          <Link href="/coaching-pdf" className="btn btn-primary" style={{ marginTop: 24, minHeight: 50, padding: "0 26px", fontSize: 15 }}>Découvrir le programme <Arrow /></Link>
        </div>
      </div>
    </PageShell>
  )
}

// Mise en page des pages compte : photo à gauche, formulaire à droite
export function AuthLayout({ title, subtitle, children }) {
  return (
    <PageShell>
      <div className="auth-grid">
        <div className="auth-visual" style={{ position: "relative", backgroundColor: "#FBE9EE", display: "flex", alignItems: "center", justifyContent: "center", padding: "48px" }}>
          <div style={{ width: "100%", maxWidth: 380 }}>
            <div style={{ position: "relative", aspectRatio: "4 / 5", borderRadius: "9999px 9999px 0 0", overflow: "hidden", backgroundColor: "#F3E4DD" }}>
              <Image src="/images/dayafit10.jpg" alt="Portrait de Daya, souriante" fill sizes="380px" style={{ objectFit: "cover", objectPosition: "center 20%" }} />
            </div>
            <p className="hand" style={{ marginTop: 20, textAlign: "center", fontSize: 26, lineHeight: 1.15, color: "#A8506A" }}>une séance à la fois ♡</p>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "clamp(40px, 6vw, 72px) var(--fbd-gutter)" }}>
          <div style={{ width: "100%", maxWidth: 420 }}>
            <h1 className="t-h2">{title}</h1>
            {subtitle && <p className="t-body" style={{ marginTop: 10, fontSize: 15 }}>{subtitle}</p>}
            <div style={{ marginTop: 28 }}>{children}</div>
          </div>
        </div>
      </div>
    </PageShell>
  )
}

export function Logo({ href = "/" }) {
  return (
    <Link href={href} className="logo" style={{ textDecoration: "none", color: "#3D2A31", display: "flex", alignItems: "baseline", gap: 7, fontSize: 14, fontWeight: 700, letterSpacing: "0.3em", whiteSpace: "nowrap" }}>
      FIT <span className="serif" style={{ fontStyle: "italic", fontSize: 19, letterSpacing: 0, color: "#C46F88" }}>by</span> DAYA
    </Link>
  )
}

export function Arrow() {
  return <span className="arr" aria-hidden="true">→</span>
}

export function Check({ size = 22, color = "#C46F88" }) {
  return (
    <svg width={size + 4} height={size} viewBox="0 0 26 22" fill="none" aria-hidden="true" style={{ flex: "none" }}>
      <path d="M2 12c3 2 6 5 8 8 4-8 9-14 14-18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

// Vraie couverture du PDF (public/images/couverture-pdf.png, 575×817)
export function PdfCover({ sizes = "300px", priority = false, style }) {
  return (
    <div style={{ position: "relative", width: "100%", aspectRatio: "575 / 817", backgroundColor: "#FFFFFF", overflow: "hidden", ...style }}>
      <Image src="/images/couverture-pdf.png" alt="Couverture du programme Fit by Daya : Affiner, tonifier et briller — 60 jours" fill sizes={sizes} priority={priority} style={{ objectFit: "cover" }} />
    </div>
  )
}

export function SiteHeader({ links, cta }) {
  return (
    <header style={{ position: "sticky", top: 0, zIndex: 50, backgroundColor: "rgba(251, 247, 244, 0.94)", borderBottom: "1px solid #EFC3CF", backdropFilter: "blur(8px)" }}>
      <div className="wrap" style={{ height: 72, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
        <Logo href="/#top" />
        {links && (
          <nav className="nav-d" aria-label="Navigation principale" style={{ alignItems: "center", gap: 36, fontSize: 14, fontWeight: 500 }}>
            {links.map(([href, label]) => <a key={href} className="ul" href={href} style={{ color: "#3D2A31" }}>{label}</a>)}
          </nav>
        )}
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {cta}
          {links && <MobileMenu links={links} socials={SOCIALS} />}
        </div>
      </div>
    </header>
  )
}

export function SiteFooter() {
  return (
    <footer className="foot-pad" style={{ backgroundColor: "#FBF7F4", borderTop: "1px solid #EFC3CF" }}>
      <div className="wrap" style={{ paddingTop: "clamp(56px, 7vw, 96px)" }}>
        <p className="serif" style={{ fontSize: "clamp(32px, 4.4vw, 64px)", lineHeight: 1.08, letterSpacing: "-0.02em", maxWidth: 900 }}>
          Le meilleur programme, c’est celui <em className="em">que tu tiens.</em>
        </p>
        <div style={{ marginTop: "clamp(48px, 6vw, 80px)", display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "flex-end", gap: 32, paddingBottom: 32, borderBottom: "1px solid #EFC3CF" }}>
          <Logo href="/#top" />
          <nav aria-label="Liens de pied de page" style={{ display: "flex", flexWrap: "wrap", gap: "8px 28px", fontSize: 14, fontWeight: 500 }}>
            {[...SOCIALS, ["mailto:hello@fitbydaya.com", "Contact"], ["/#faq", "FAQ"]].map(([href, label]) => (
              <a key={href} className="ul" href={href} style={{ color: "#3D2A31", minHeight: 44, display: "inline-flex", alignItems: "center" }}>{label}</a>
            ))}
          </nav>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", gap: "12px 24px", padding: "22px 0 0", fontSize: 12, color: "#7A5D67" }}>
          <span>© 2026 Fit by Daya · fait avec patience ♡</span>
          <span style={{ display: "flex", flexWrap: "wrap", gap: "8px 20px" }}>
            <a href="#" style={{ color: "#7A5D67" }}>Mentions légales</a>
            <a href="#" style={{ color: "#7A5D67" }}>CGV</a>
            <a href="#" style={{ color: "#7A5D67" }}>Confidentialité</a>
          </span>
        </div>
      </div>
    </footer>
  )
}
